module.exports = __webpack_public_path__ + "static/UNITY-Tower-lower-floor-traditional_v2-en-afe8fe7a1c59b8890eafa100f1652249.pdf";